<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">Edit member personal data</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content *ngIf="!loader && !editmode">
  <div class="row">
    <div class="col-sm-12">
      <div class="member_profile">
        <div class="bgt_colorkk"></div>
        <img
          [src]="memberDetailsData.image_thumb_url"
          onerror="this.src='../../../../assets/images/user-avatar.svg'"
          alt=""
        />
      </div>
      <div
        style="
          margin-bottom: 30px;
          display: flex;
          align-items: baseline;
          text-decoration: underline;
          justify-content: end;
        "
      >
        <div>
          <span
            class="material-icons icon_mat"
            style="font-size: 20px; top: 5px"
          >
            edit
          </span>
        </div>
        <div style="cursor: pointer" (click)="onEdit()">Edit</div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> person </span>
          </div>
          <div class="entity_detail make_text_grey">Name</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{ memberDetailsData.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> call </span>
          </div>
          <div class="entity_detail make_text_grey">Phone</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{ memberDetailsData.country_code }} {{ memberDetailsData.phone }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> mail </span>
          </div>
          <div class="entity_detail make_text_grey">Email</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{
              memberDetailsData.email
                ? memberDetailsData.email
                : "No email added"
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> transgender </span>
          </div>
          <div class="entity_detail make_text_grey">Gender</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{ memberDetailsData.gender }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> calendar_month </span>
          </div>
          <div class="entity_detail make_text_grey">DOB</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{
              memberDetailsData.dob
                ? (memberDetailsData.dob | date)
                : "No DOB added"
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> calendar_month </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Membership start date
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.membership_start_date | date }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> settings </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Service mode
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.s_mode }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted services
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="memberDetailsData.opted_services"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_services }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_services"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No opted services
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted products
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="memberDetailsData.opted_products"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_products }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_products"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No opted products
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Other items
          </div>
        </div>
        <div class="sub_one_cont main_text" *ngIf="memberDetailsData.opted_cis">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_cis }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_cis"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No other items
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="memberDetailsData.timings && memberDetailsData.timings != 'null'"
    >
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> work_history </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted timings
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px">
            <mat-chip-list aria-label="sunday">
              <mat-chip *ngFor="let item of memberDetailsData.opted_timings">
                {{ item }}
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Subscription fees</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.membership_fee &&
              memberDetailsData.membership_fee != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.membership_fee.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.membership_fee ||
              memberDetailsData.membership_fee == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Discount</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.discount && memberDetailsData.discount != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.discount.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.discount ||
              memberDetailsData.discount == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Net payable</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.net_payable &&
              memberDetailsData.net_payable != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.net_payable.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.net_payable ||
              memberDetailsData.net_payable == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Notes</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{
              memberDetailsData.notes && memberDetailsData.notes != "null"
                ? memberDetailsData.notes
                : "No notes added"
            }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="
        memberDetailsData.billing_period &&
        memberDetailsData.billing_period != 'null'
      "
    >
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Billing period</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 1"
          >
            Weekly
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 2"
          >
            Monthly
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 3"
          >
            Yearly
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-content *ngIf="editmode">
  <div class="row">
    <div class="col-sm-12" style="margin-top: 100px">
      <div class="lkl">
        <div class="gfg_ig_ht">
          <div class="pcg_img">
            <a href="javascript:void(0)" class="card-icon">
              <img
                [src]="memberimg.img"
                alt=""
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              />
            </a>
            <div class="un_ld_img" (click)="triggerFileInput.click()">
              <a href="javascript:void(0)">
                <mat-icon
                  style="
                    font-size: 25px;
                    color: #ffc107;
                    position: relative;
                    top: 4px;
                    left: -1px;
                  "
                  >add_a_photo</mat-icon
                >
                <input
                  #triggerFileInput
                  type="file"
                  accept="image/*"
                  name="img"
                  id="imagepick"
                  class="upload"
                  (change)="onUploadImage($event)"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="memberData.name" matInput />
    </mat-form-field>
  </div>
  <!-- <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="memberData.customerPh" matInput  type="tel" smNumericOnly
        maxlength="10"/>
        
      </mat-form-field>
    </div> -->
  <div class="row g-2 justify-content-between phone-field">
    <mat-form-field appearance="outline" class="country-code col-3">
      <mat-label>Country Code</mat-label>
      <mat-select
        [disabled]="editmode"
        [(ngModel)]="selectedCountryCode"
        required
        (selectionChange)="onCountrySelected($event)"
      >
        <mat-select-trigger>
          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
          {{ "(" + selectedCountryCode.dial_code + ")" }}
        </mat-select-trigger>

        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="no results found"
            name="countrysearch"
            placeholderLabel="Enter country name"
            [formControl]="searchString"
            (keyup)="onKey()"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let country of countryList" [value]="country">
          {{ country.flag }} {{ country.name }}
          {{ "(" + country.dial_code + ")" }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="mobile_form col-9" appearance="outline">
      <mat-label>Phone</mat-label>
      <input
        [disabled]="editmode"
        [(ngModel)]="memberData.phone"
        matInput
        type="tel"
        smNumericOnly
        minLength="3"
        maxlength="17"
      />
      <mat-hint
        style="color: red; font-size: 13px"
        align="end"
        *ngIf="
          memberData.phone &&
          memberData.phone != '' &&
          memberData.phone.length < 3
        "
        >Please enter a valid phone number in the range of 3-17.</mat-hint
      >
    </mat-form-field>
  </div>
 <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Address</mat-label>
      <input [(ngModel)]="memberData.address" matInput maxlength="400"/>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field
      class="w-100"
      appearance="outline"
      class="col-12"
      (click)="picker0.open()"
      style="padding: 0px"
    >
      <mat-label>DOB</mat-label>
      <input
        matInput
        [matDatepicker]="picker0"
        [(ngModel)]="memberData.dob"
        readonly
      />

      <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
      <mat-datepicker #picker0 disabled="false"></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="radio_group">
    <label>Gender: </label>
    <mat-radio-group [(ngModel)]="memberData.gender">
      <mat-radio-button value="Male">Male</mat-radio-button>
      <mat-radio-button value="Female">Female</mat-radio-button>
      <mat-radio-button value="Others">Others</mat-radio-button>
    </mat-radio-group>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Email</mat-label>
      <input matInput [(ngModel)]="memberData.email" />
    </mat-form-field>
  </div>

  <div>
    <mat-form-field
      class="w-100"
      appearance="outline"
      class="col-12"
      (click)="picker1.open()"
      style="padding: 0px"
    >
      <mat-label>Start date</mat-label>
      <input
        matInput
        [matDatepicker]="picker1"
        [(ngModel)]="memberData.start_date"
        readonly
      />

      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1 disabled="false"></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="editmode">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="accent"
    [disabled]="
      formChecker() ||
      namechecker() ||
      !memberData.start_date 
    "
    (click)="onPost()"
  >
    Confirm
  </button>
</mat-dialog-actions>
